import React, { useEffect } from "react";
import "./pages.css";
import {
    getUserStatsObject,
    getUrlDetailsObj,
    recordActivity
} from '../../../services/commonService';
import { useLocation, useParams } from "react-router-dom";
import { PROJECT_DISPLAY_NAME } from "../../../config/apiConfig";

export default function HelpAccountIQ() {

    const { accountId, accountName } = useParams();
    var pageParsedData = getUrlDetailsObj(useLocation, useParams);
    pageParsedData.query_params = {}
    pageParsedData.query_params.tab = 'help_document';

    useEffect(() => {
      let userStat = getUserStatsObject(
        "Help Section",
        "help_section_visit",
        "Page Source: "+PROJECT_DISPLAY_NAME,
        window.location.href,
        accountId
      );
      userStat.url_details = pageParsedData;
      recordActivity(userStat);      
    }, []);

    const openItemInNewTab = (type = "", url = "") => {
      let tab_type = type == "document" ? "Document" : "Video";
      let action_type = type == "document" ? "document" : "video";
      let userStat = getUserStatsObject(
        "Help "+tab_type,
        "help_"+action_type+"_view",
        "Page Source: "+PROJECT_DISPLAY_NAME,
        window.location.href,
        accountId
      );
      userStat.url_details = pageParsedData;
      recordActivity(userStat);
      window.open(url, '_blank');
    };

   return (
    <div>
      <div className="accountiq_help_wrapper">
        <div className="container">
          <div className="row">
            <div className="row">
              <div className="col-md-6">
                <div className="iq_help_block">
                  <div className="acc_main_head">
                    <h1> Elevate Sales Strategies with {PROJECT_DISPLAY_NAME} </h1>
                    <p className="para mb-1">
                      {PROJECT_DISPLAY_NAME} empowers sales professionals with actionable
                      insights to optimize account strategies and drive growth.{" "}
                    </p>
                    <p className="para mb-1">Here's what you can expect:</p>
                    <ul className="list_help_block mb-4">
                      <li className="list_help">
                        <strong>Comprehensive Account Insights:</strong> Access
                        financial data, industry trends, and recent
                        developments.
                      </li>
                      <li className="list_help">
                        <strong>Business Structure Clarity:</strong> To uncover
                        investment potential, focus on growing or declining
                        segments.
                      </li>
                      <li className="list_help">
                        <strong>Growth Opportunities & Trends:</strong> Stay
                        updated on new projects, tech investments, and strategic
                        initiatives.
                      </li>
                      <li className="list_help">
                        <strong>Actionable Prompters & Nudges:</strong> Get
                        tailored suggestions for reconnecting and influencing
                        stakeholders.
                      </li>
                      <li className="list_help">
                        <strong>Validated Contacts:</strong> Leverage
                        high-accuracy contact details with LinkedIn-enabled
                        profiles.
                      </li>
                      <li className="list_help">
                        <strong>AI Support:</strong> Quickly search for insights
                        or get help from live analysts.
                      </li>
                    </ul>
                  </div>
                  <a href="#" target="_blank">
                    <button
                      type="button"
                      className="btn btn-light pdf_view_btn mr-3"
                      onClick={() => openItemInNewTab('document', '/help_document/sales_iq_help.pdf')}
                    >
                      Help Document
                    </button>
                  </a>
                  <a href="#" target="_blank">
                    <button
                        type="button"
                        className="btn btn-light video_btn"
                        onClick={() => openItemInNewTab('video', 'https://youtu.be/ovpqREQpyJg')}
                    >
                      Help Video
                    </button>
                  </a>
                </div>
              </div>
              <div className="col-md-6">
                <div className="help_img_block">
                  <img
                    src="/img/help_img.png"
                    className="help_img"
                    alt="image_help"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
